module.exports = __webpack_public_path__ + "img/10.28a8a709.png";